<template>
  <div class="settingsview-container">
    <headerbar/>
    <div class="go-back" @click="$router.go(-1)"><i class="fa fa-chevron-left"/></div>

    <div class="content">
      <div class="title">Settings</div>
      <div class="avatar">
        <img :src="user.picture"/>
      </div>
      <div class="settings">
        Your subscription type: {{ subscription.type }} <br/>
        Valid until: {{ validUntil }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Headerbar from '@/components/Headerbar.vue'

export default {
  name: 'SettingsView',
  components: {
    Headerbar,
  },
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    name() {

    }
  },
  computed: {
    subscription() {
      return this.$store.getters.subscription
    },
    validUntil() {
      if(this.subscription != {}) {
        return moment(this.subscription.validUntil).format('LL')
      }
      return ''
    },
    user() {
      return this.$store.getters.user || {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.content {
  padding: 50px;
  text-align: left;
  display: inline-block;
}

.title {
  font-size: 24px;
  font-weight: 700;
  padding: 10px 0px;
  margin: 30px 0px;
}

.avatar {
  margin-bottom: 30px;
  
  img {
    border-radius: 50%;
    max-width: 50px;
    max-height: 50px;
  }
}
</style>